// redux utils
import { createAsyncThunk } from '@reduxjs/toolkit';
import { downloadLink } from '@insticator/insticator-ui/dist/utils/files.js';
// api
import * as pa from './api/pa'

// thunks
export const fetchTotalAnswersReport = createAsyncThunk(
    'triviapolls/fetchTotalAnswersReport',
    async (requestData) => {
        const response = await pa.postTotalAnswersRequest(requestData);
        return response.data
    }
);

export const fetchUniqueTriviaUsersReport = createAsyncThunk(
    'triviapolls/fetchUniqueTriviaUsersReport',
    async ({ requestData }) => {
        const response = await pa.postUniqueTriviaUsersRequest({ requestData });
        return response.data
    }
);

export const fetchTriviaEngagementRateReport = createAsyncThunk(
  'triviapolls/fetchTriviaEngagementRateReport',
  async ({ requestData }) => {
      const response = await pa.postTriviaEngagementRateRequest({ requestData });
      return response.data
  }
);

export const fetchTopCardsReport = createAsyncThunk(
    'triviapolls/fetchTopCardsReport',
    async ({ interval, requestData }) => {
        const response = await pa.postTopCardsRequest({ interval, requestData });
        return response.data
    }
);

export const fetchTopSkippedReport = createAsyncThunk(
    'triviapolls/fetchTopSkippedReport',
    async ({ interval, requestData }) => {
        const response = await pa.postTopSkippedRequest({ interval, requestData });
        return response.data
    }
);

export const fetchTopSkippedCardsExportAll = createAsyncThunk(
    'commenting/fetchTopSkippedCardsExportAll',
    async (requestData) => {
        const response = await pa.postTopSkippedCardsExportAllRequest(requestData);
        if(response?.data?.exportedFileUrl){
            //download file
            downloadLink(response.data.exportedFileUrl)
        }
        return response.data
    }
);

export const fetchTopPollsExportAll = createAsyncThunk(
    'commenting/fetchTopPollsExportAll',
    async (requestData) => {
        const response = await pa.postTopPollsExportAllRequest(requestData);
        if(response?.data?.exportedFileUrl){
            //download file
            downloadLink(response.data.exportedFileUrl)
        }
        return response.data
    }
);

export const fetchAvgInViewReport = createAsyncThunk(
    'triviapolls/fetchAvgInViewReport',
    async (requestData) => {
        const response = await pa.postTriviaAvgInViewData(requestData);
        return response.data
    }
);